import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2, ArrowLeft, MailCheck, KeyRound } from "lucide-react";
import { api } from "@/lib/api";

export default function AdminForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      // still show success to avoid leaking which emails exist
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full rounded-xl bg-navy-soft border border-white/10 px-4 py-3 text-sm text-white placeholder:text-slate-500 focus:outline-none focus:border-cyan/60 focus:ring-2 focus:ring-cyan/20 transition-all";

  return (
    <div className="min-h-screen grain relative bg-navy text-white grid place-items-center px-4">
      <div className="absolute -top-20 left-1/2 -translate-x-1/2 w-[40rem] h-[40rem] radial-glow z-0" />
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        className="relative z-10 w-full max-w-md rounded-3xl border border-white/10 bg-navy-card/70 backdrop-blur-xl p-8"
      >
        <Link to="/admin/login" className="inline-flex items-center gap-1.5 text-xs text-slate-400 hover:text-cyan transition mb-6">
          <ArrowLeft className="w-3.5 h-3.5" /> Kembali ke login
        </Link>

        {sent ? (
          <div data-testid="forgot-success" className="text-center py-6">
            <span className="mx-auto grid place-items-center w-14 h-14 rounded-2xl bg-cyan/10 text-cyan mb-4">
              <MailCheck className="w-7 h-7" />
            </span>
            <h1 className="font-heading font-bold text-2xl">Cek email Anda</h1>
            <p className="text-sm text-slate-400 mt-2 leading-relaxed">
              Jika email terdaftar, kami telah mengirim tautan untuk mengatur ulang kata sandi. Tautan berlaku 1 jam.
            </p>
            <Link to="/admin/login" className="mt-6 inline-flex rounded-xl bg-gold px-6 py-3 text-sm font-bold text-navy hover:shadow-[0_0_24px_rgba(212,175,55,0.4)] transition">
              Kembali ke Login
            </Link>
          </div>
        ) : (
          <>
            <h1 className="font-heading font-bold text-2xl flex items-center gap-2">
              <KeyRound className="w-5 h-5 text-gold" /> Lupa Kata Sandi
            </h1>
            <p className="text-sm text-slate-400 mt-1.5">Masukkan email akun Anda. Kami akan mengirim tautan pemulihan.</p>
            <form onSubmit={submit} className="mt-7 space-y-4" data-testid="forgot-form">
              <div>
                <label className="text-sm text-slate-300 font-medium">Email</label>
                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className={`mt-2 ${inputCls}`} placeholder="admin@binaralabs.id" required data-testid="forgot-email" />
              </div>
              <button type="submit" disabled={loading} data-testid="forgot-submit" className="w-full inline-flex items-center justify-center gap-2 rounded-xl bg-gold px-6 py-3.5 font-body font-bold text-navy hover:shadow-[0_0_30px_rgba(212,175,55,0.4)] disabled:opacity-60 transition-all duration-300">
                {loading && <Loader2 className="w-5 h-5 animate-spin" />} Kirim Tautan
              </button>
            </form>
          </>
        )}
      </motion.div>
    </div>
  );
}
